import { gsap } from "gsap";

export const navOpen = async (ref, state) => {
  state(true)

  await gsap
    .fromTo(ref.current, {
      autoAlpha: 1,
      height: 16,
      ease: 'none',
      delay: 0
    },
      {
        duration: .3,
        autoAlpha: 1,
        height: 236,
        ease: 'none',
        delay: 0
      })
}

export const navClose = async (ref, state) => {
  await gsap
    .fromTo(ref.current, {
      autoAlpha: 1,
      height: 236,
      ease: 'none',
      delay: 0
    },
      {
        duration: .3,
        autoAlpha: 1,
        height: 16,
        ease: 'none',
        delay: 0
      })

  state(false)
}

export const projectDataLeft = async (ref) => {
  await gsap
    .fromTo(ref.current, {
      autoAlpha: 0,
      x: -236,
      ease: 'none',
      delay: 0
    },
      {
        duration: .8,
        autoAlpha: 1,
        x: 0,
        ease: 'none',
        delay: .5
      })
}

export const projectDataRight = async (ref) => {
  await gsap
    .fromTo(ref.current, {
      autoAlpha: 0,
      x: 366,
      ease: 'none',
      delay: 0
    },
      {
        duration: .8,
        autoAlpha: 1,
        x: 0,
        ease: 'none',
        delay: .5
      })
}